import { render } from "./RestoreSvgIcon.vue?vue&type=template&id=197d432e"
import script from "./RestoreSvgIcon.vue?vue&type=script&lang=js"
export * from "./RestoreSvgIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__